import axios from 'axios';

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_BACKEND_URL,
});

export const fetchAgent = async (agentId) => {
  const response = await axiosInstance.get(`/public/agents/${agentId}`);
  return response.data;
};

export const fetchAgentProperties = async (agentId) => {
  const response = await axiosInstance.get(
    `/public/properties?pageSize=100000&agentId=${agentId}`
  );
  return response.data;
};

export const fetchAgents = async () => {
  const response = await axiosInstance.get(`/public/agents/`);
  return response.data;
};

export const fetchProperty = async (propertyId) => {
  const response = await axiosInstance.get(`/public/properties/${propertyId}`);
  return response.data;
};

export const fetchProperties = async ({
  assetTypeId,
  locationTypeId,
  numberOfBathrooms,
  numberOfBedrooms,
  priceRange,
  propertyTypeId,
  minRate,
  maxRate,
}) => {
  console.log({
    assetTypeId,
    locationTypeId,
    numberOfBathrooms,
    numberOfBedrooms,
    priceRange,
    propertyTypeId,
    minRate,
    maxRate,
  });
  const response = await axiosInstance.get(
    `/public/properties?pageSize=100000&${
      assetTypeId ? `assetTypeId=${assetTypeId}&` : ''
    }${locationTypeId ? `locationTypeId=${locationTypeId}&` : ''}${
      numberOfBathrooms ? `numberOfBathrooms=${numberOfBathrooms}&` : ''
    }${numberOfBedrooms ? `numberOfBedrooms=${numberOfBedrooms}&` : ''}${
      priceRange ? `minRate=${minRate}&maxRate=${maxRate}&` : ''
    }${propertyTypeId ? `propertyTypeId=${propertyTypeId}&` : ''}`
  );
  return response.data;
};

export const fetchInitialProperties = async () => {
  const response = await axiosInstance.get(
    `/public/properties?pageSize=100000`
  );
  return response.data;
};

export const fetchRecentProperties = async () => {
  const response = await axiosInstance.get(`/public/properties?pageSize=4`);
  return response.data;
};

export const fetchSimilarProperties = async (locationTypeId, assetTypeId) => {
  const response = await axiosInstance.get(
    `/public/properties?pageSize=3&locationTypeId=${locationTypeId}&assetTypeId=${assetTypeId}`
  );
  return response.data;
};

export const sendAgentNotification = async ({ agentId, body }) => {
  const response = await axiosInstance.post(`/public/notification`, {
    body: body,
    agentId: agentId,
  });
  return response.data;
};

export const sendAdminNotification = async ({ body }) => {
  const response = await axiosInstance.post(`/public/notification`, {
    body: body,
  });
  return response.data;
};

export const uploadPropertyPictures = async (files) => {
  let formData = new FormData();
  for (let i = 0; i < files.length; i++) {
    formData.append('files', files[i]);
  }
  return axiosInstance.post('/public/pictures', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};

const fetchAgentPropertyList = async (agentId) => {};
